// source: type/container_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.ContainerType', null, global);
/**
 * @enum {number}
 */
proto.type.ContainerType = {
  CONTAINER_DRY: 0,
  CONTAINER_CHILLED: 1,
  CONTAINER_FROZEN: 2,
  NO_CONTAINER: 3
};

goog.object.extend(exports, proto.type);
